interface ChevronDownIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
}

export default function ChevronDownIcon({
  width = 24,
  height = 25,
  color = 'currentColor',
  className,
}: ChevronDownIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M16.7998 10.389L11.9998 15.189L7.19981 10.389"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
